// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-slider[data-v-ba2c8ba4] .v-image__image--cover{background-position:left !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
